import { Pipe, PipeTransform } from '@angular/core';
import { UserOrganizationSearchOrder } from '@app-types/enums/UserOrganizationSearchOrder';

@Pipe({
  name: 'formatUsersSearchOrders',
  standalone: true,
})
export class FormatUsersSearchOrders implements PipeTransform {
  transform(order: string): UserOrganizationSearchOrder {
    switch (order) {
      case 'firstName':
        return UserOrganizationSearchOrder.OrderByFirstName;
      case 'lastName':
        return UserOrganizationSearchOrder.OrderByLastName;
      case 'oidcIdentity':
        return UserOrganizationSearchOrder.OrderByOidcIdentity;
      case 'adfsIdentity':
        return UserOrganizationSearchOrder.OrderByAdfsIdentity;
      case 'email':
        return UserOrganizationSearchOrder.OrderByEmail;
      case 'role':
        return UserOrganizationSearchOrder.OrderByRole;
      case 'state':
        return UserOrganizationSearchOrder.OrderByState;
      default:
        return UserOrganizationSearchOrder.OrderByUserOrganizationId;
    }
  }
}
